export default __webpack_public_path__ + "static/media/01_DAIF_Data_02_01-end.73412a18.jpg";